import ProjectList from '../components/ProjectList';

export default function Projects() {
    return (<div className="container mx-auto min-h-full">
        <ProjectList></ProjectList>
    </div>)
}